import {SprayWeatherModel} from '../../model/weather/SprayWeatherModel';
import {BaseCollection} from '../BaseCollection';

/**
 * @class SprayWeatherCollection
 * @extends BaseCollection
 */
export class SprayWeatherCollection extends BaseCollection {

    get model () {

        return SprayWeatherModel;
    }

    initialize (models, options) {

        super.initialize(models, options);

        this.microservice = 'rule-engine';
        this.resource = 'spray-weather';
    }

    static get OBJECT_TYPES () {

        return {
            FIELD: 'FIELD',
            CROPSEASON: 'CROPSEASON'
        };
    }

    static get modelUuid () {

        return '06682c22-42fc-44d4-a88f-0e64942a1210';
    }
}


// WEBPACK FOOTER //
// ./shared/collection/weather/SprayWeatherCollection.js